import { useEffect } from "react";

import { Utils } from "./../../common";

const Home = () => {
  useEffect(() => {
    window.location.href =
      process.env.PUBLIC_URL + (Utils.isLoggedIn() ? "/dashboard" : "/login");
  }, []);

  return <>loading..</>;
};

export default Home;
